module.exports = __webpack_public_path__ + "img/brand(3).f5ef6dbb.png";